import { render, staticRenderFns } from "./RelativeRelations.vue?vue&type=template&id=a1ccd542&"
import script from "./RelativeRelations.vue?vue&type=script&lang=js&"
export * from "./RelativeRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports